// extracted by mini-css-extract-plugin
export default {"PageSectionHeading":"FrR9v_ssranAjR5kDzwF"};